import React, { useContext } from 'react';

export const AppContext = React.createContext();

export const useApp = () => useContext(AppContext);
export default AppContext;
